module.exports = __webpack_public_path__ + "img/search-not-found.52e9c2fa.svg";